import axios from "axios";
import { useRef, useState } from "react";

const BASE_URL = process.env.REACT_APP_BASE_URL;

const UploadView = ({ user }) => {
  const [imagePreview, setImagePreview] = useState(null);
  const [imageURL, setImageURL] = useState("");
  const [imageFile, setImageFile] = useState(null);
  const [loading, setLoading] = useState(false);

  const [copied, setCopied] = useState(false);

  const fileInputRef = useRef(null);

  // const queryParams = new URLSearchParams(window.location.search);
  // const token = queryParams.get("token");

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file && file.type.startsWith("image/")) {
      setImageFile(file);

      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = async () => {
    if (!imageFile) return alert("Please upload an image first.");
    setLoading(true);
    const formData = new FormData();
    formData.append("image", imageFile);

    try {
      const response = await axios.post(`${BASE_URL}/api/upload`, formData, {
        auth: {
          username: user.username,
          password: user.apiKey,
        },
      });

      if (response.status === 200) {
        setImageURL(response.data.imageUrl);
      } else {
        alert(
          "Upload failed: " + (response.data.response_msg || "Unknown error.")
        );
      }
    } catch (error) {
      if (error.response && error.response.data) {
        const { response_msg, message } = error.response.data;
        alert(`Upload failed: ${response_msg || message || "Unknown error."}`);
      } else {
        console.error("Upload failed:", error);
        alert("Upload failed: " + error.message);
      }
    } finally {
      setLoading(false);
    }
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(imageURL).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000); // hide after 2s
    });
  };

  return (
    <div className="max-w-xl w-full bg-white rounded-2xl shadow-xl p-6">
      <div className="flex flex-col gap-2 justify-center mb-6">
        <img src="/logo.svg" alt="ClickSend Logo" className="h-10" />
        <p className="text-sm text-center text-gray-600">
          Upload your images and get an image URL instantly.
        </p>
      </div>

      <div
        className="border-2 border-dashed border-blue-300 rounded-xl h-56 flex items-center justify-center bg-blue-50 hover:bg-blue-100 cursor-pointer transition"
        onClick={() => fileInputRef.current.click()}
      >
        {imagePreview ? (
          <img
            src={imagePreview}
            alt="Preview"
            className="h-full w-full object-contain rounded-xl"
          />
        ) : (
          <span className="text-blue-400 font-semibold">+ Add Image</span>
        )}
      </div>

      <input
        type="file"
        accept="image/*"
        className="hidden"
        ref={fileInputRef}
        onChange={handleImageChange}
      />

      <a
        href="https://help.clicksend.com/article/ek4bc3mded-supported-media-formats"
        target="_blank"
        rel="noopener noreferrer"
        className="text-sm text-blue-600 hover:underline mt-2"
      >
        See image file specs.
      </a>

      <button
        disabled={loading}
        onClick={handleSubmit}
        className={`mt-6 w-full py-2 px-4 rounded-xl font-medium transition
    ${
      loading
        ? "bg-gray-400 cursor-not-allowed text-gray-500"
        : "bg-[#00AAFF] hover:bg-blue-700 text-white"
    }
  `}
      >
        {loading ? "Uploading..." : "Upload"}
      </button>

      {!loading && imageURL && (
        <div className="mt-4 p-3 border rounded-lg bg-gray-50">
          <label className="text-sm text-gray-600">Image URL:</label>
          <div className="relative inline-block mt-1 w-full">
            <div className="flex items-center">
              <input
                type="text"
                value={imageURL}
                readOnly
                className="flex-1 border border-gray-300 rounded-l-md px-3 py-1 text-sm bg-white"
              />

              <div className="relative flex flex-col items-center">
                {/* Tooltip above the button */}
                <div
                  className={`absolute -top-6 text-xs text-white bg-green-500 px-2 py-0.5 rounded shadow transition-all duration-300
              ${
                copied ? "opacity-100 translate-y-0" : "opacity-0 translate-y-2"
              }`}
                >
                  Copied!
                </div>

                <button
                  onClick={handleCopy}
                  className="bg-gray-200 hover:bg-gray-300 px-3 py-1 rounded-r-md text-sm"
                >
                  Copy
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default UploadView;
